import types from '@/types';
import { useAppStore } from '@/stores/app';

const SetupData = async () => {
  const appStore = useAppStore();
  await appStore[types.SETUP_APP]();
};

export default SetupData;
